import type {
  AdminDisputeDetail,
  AdminDisputeEvidence,
} from "@/types/admin-dispute";
import type { MockUserId } from "@/lib/api/mock-data/users.mock";

export const MOCK_DISPUTES: Record<string, AdminDisputeDetail> = {
  dp_001: {
    disputeId: "dp_001",
    userId: "u_006_finn_past_due",
    membershipId: "m_006",
    status: "dispute_pending",
    amountMinor: 9_900,
    currency: "EUR",
    reason: "Cardholder claims unauthorized renewal charge.",
    openedAt: "2026-05-12T11:30:00Z",
    evidenceDueBy: "2026-05-26T23:59:59Z",
    network: "stripe",
    resolvedAt: null,
    outcome: null,
    internalNotes: "Awaiting shipping proof + consent snapshot.",
  },
  dp_002: {
    disputeId: "dp_002",
    userId: "u_005_erin_charged_off",
    membershipId: "m_005",
    status: "dispute_lost",
    amountMinor: 84_000,
    currency: "EUR",
    reason: "Cardholder disputed trial charge-off fee.",
    openedAt: "2026-04-05T08:00:00Z",
    evidenceDueBy: "2026-04-19T23:59:59Z",
    network: "stripe",
    resolvedAt: "2026-05-02T09:00:00Z",
    outcome: "lost",
    internalNotes: "Insufficient documentation of return non-arrival.",
  },
  dp_003: {
    disputeId: "dp_003",
    userId: "u_004_dave_card_failed",
    membershipId: "m_004",
    status: "dispute_pending",
    amountMinor: 84_000,
    currency: "DKK",
    reason: "Cardholder claims the trial enrollment was unauthorized.",
    openedAt: "2026-05-18T09:00:00Z",
    evidenceDueBy: "2026-06-01T23:59:59Z",
    network: "stripe",
    resolvedAt: null,
    outcome: null,
    internalNotes: "Pending negative-option disclosure pull.",
  },
};

export const MOCK_DISPUTE_EVIDENCE: Record<string, AdminDisputeEvidence> = {
  dp_001: {
    disputeId: "dp_001",
    shippingProofUrl: null,
    consentSnapshotUrl: null,
    usageStatsSummary: null,
    customerCommunication: null,
    refundOfferedMinor: null,
    submittedAt: null,
    negativeOptionDisclosure: {
      accepted: true,
      acceptedAt: "2025-09-05T16:01:00Z",
      version: "neg-opt-2025-08-12",
      source: "web_checkout",
    },
  },
  dp_002: {
    disputeId: "dp_002",
    shippingProofUrl: "https://mock.zone/evidence/dp_002/shipping.pdf",
    consentSnapshotUrl: "https://mock.zone/evidence/dp_002/consent.json",
    usageStatsSummary: "12 sessions across 21 days post-delivery.",
    customerCommunication: "Two emails sent, no reply.",
    refundOfferedMinor: 0,
    submittedAt: "2026-04-18T10:00:00Z",
    negativeOptionDisclosure: {
      accepted: true,
      acceptedAt: "2026-02-15T09:30:00Z",
      version: "neg-opt-2026-01-01",
      source: "web_checkout",
    },
  },
  dp_003: {
    disputeId: "dp_003",
    shippingProofUrl: null,
    consentSnapshotUrl: null,
    usageStatsSummary: null,
    customerCommunication: null,
    refundOfferedMinor: null,
    submittedAt: null,
    negativeOptionDisclosure: {
      accepted: false,
    },
  },
};

export const MOCK_USER_DISPUTE_IDS: Partial<Record<MockUserId, string[]>> = {
  u_004_dave_card_failed: ["dp_003"],
  u_005_erin_charged_off: ["dp_002"],
  u_006_finn_past_due: ["dp_001"],
};
